import React, { useContext, useEffect, useState,useRef } from 'react'
import { Table, DatePicker, Select, Button, message, Tabs, Spin, Cascader, Tag, Row, Col ,Dropdown,Space,Menu} from 'antd'
import { DownOutlined } from '@ant-design/icons'
import { StateContext} from '../../../state';
import { StateDeviceContext } from '../../../state_device';
import http from '../../../../../utils/server'
import { Line } from '@ant-design/charts';
import './style.less'
import moment from 'moment';
import { Mode } from '../../../../../App'
import html2canvas from 'html2canvas';
import Checkbox from 'antd/lib/checkbox/Checkbox';
import * as echarts from 'echarts';
import ResizeObserver from 'rc-resize-observer';
import { VariableSizeGrid as Grid } from 'react-window';

// 绘制图表
const { Option } = Select;
const { RangePicker } = DatePicker;
const { TabPane } = Tabs;
var todayTime=0;

const customWeekStartEndFormat = value =>
  `${moment(value).startOf('week').format('MM/DD')} ~ ${moment(value)
    .endOf('week')
    .format('MM/DD')}`;

function formatDateTimes(inputTime) {
    var date = new Date(inputTime);
    var y = date.getFullYear();
    var m = date.getMonth() + 1;
    m = m < 10 ? ('0' + m) : m;
    var d = date.getDate();
    d = d < 10 ? ('0' + d) : d;
    var h = date.getHours();
    h = h < 10 ? ('0' + h) : h;
    var minute = date.getMinutes();
    var second = date.getSeconds();
    minute = minute < 10 ? ('0' + minute) : minute;
    second = second < 10 ? ('0' + second) : second;
    return y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
};

function exportCsv(obj) {
    var title = obj.title;
    var titleForKey = Object.keys(obj.data[0]);
    var data = obj.data;
    var str = [];
    str.push(obj.title.join(",") + "\n");
    for (var i = 0; i < data.length; i++) {
        var temp = [];
        for (var j = 0; j < titleForKey.length; j++) {
            temp.push(data[i][titleForKey[j]]);
        }
        str.push(temp.join(",") + "\n");
    }
    var blob = new Blob(['\uFEFF' + str.join('')], {
        type: 'text/plain;charset=utf-8',
    });
    var downloadLink = document.createElement("a");
    downloadLink.href = URL.createObjectURL(blob);
    downloadLink.download = "export.csv";
    downloadLink.click();
}
var userdistrictlist;

const VirtualTable = (props) => {
    const { columns, scroll } = props;
    const [tableWidth, setTableWidth] = useState(0);
    const widthColumnCount = columns.filter(({ width }) => !width).length;
    const mergedColumns = columns.map((column) => {
      if (column.width) {
        return column;
      }
      return {
        ...column,
        width: Math.floor(tableWidth / widthColumnCount),
      };
    });
    const gridRef = useRef();
    const [connectObject] = useState(() => {
      const obj = {};
      Object.defineProperty(obj, 'scrollLeft', {
        get: () => {
          if (gridRef.current) {
            return gridRef.current?.state?.scrollLeft;
          }
          return null;
        },
        set: (scrollLeft) => {
          if (gridRef.current) {
            gridRef.current.scrollTo({
              scrollLeft,
            });
          }
        },
      });
      return obj;
    });
    const resetVirtualGrid = () => {
      gridRef.current?.resetAfterIndices({
        columnIndex: 0,
        shouldForceUpdate: true,
      });
    };
    useEffect(() => resetVirtualGrid, [tableWidth]);
  const renderVirtualList = (rawData, { scrollbarSize, ref, onScroll }) => {
    ref.current = connectObject;
    const totalHeight = rawData.length * 54;
    return (
      <Grid
        ref={gridRef}
        className="virtual-grid"
        columnCount={mergedColumns.length}
        columnWidth={(index) => {
          const { width } = mergedColumns[index];
          return totalHeight > scroll.y && index === mergedColumns.length - 1
            ? width - scrollbarSize - 1
            : width;
        }}
        height={scroll.y}
        rowCount={rawData.length}
        rowHeight={() => 54}
        width={tableWidth}
        onScroll={({ scrollLeft }) => {
          onScroll({
            scrollLeft,
          });
        }}
      >
        {({ columnIndex, rowIndex, style }) => {

            const record = rawData[rowIndex];
            const column = columns[columnIndex];
            return  <div
            style={{
                ...style,
                display: 'flex',
                alignItems: 'center',
                padding: '0 12px',
                borderBottom: '1px solid #f0f0f0',
                background: rowIndex % 2 ? '#fafafa' : 'white',
                boxSizing: 'border-box',
                justifyContent: 'center'
              }}
          >
            {/* {rawData[rowIndex][mergedColumns[columnIndex].dataIndex]} */}
            {column.render 
                ? column.render(record[column.dataIndex], record, rowIndex)
                : record[column.dataIndex]}
          </div>
        }}
      </Grid>
    );
  };
  return (
    <ResizeObserver
      onResize={({ width }) => {
        setTableWidth(width);
      }}
    >
      <Table
        {...props}
        className="virtual-table"
        columns={mergedColumns}
        pagination={false}
        components={{
          body: renderVirtualList,
        }}
      />
    </ResizeObserver>
  );
};

function History() {
    const { state, dispatch } = useContext(StateContext)
    const { state_device, dispatch_device } = useContext(StateDeviceContext)
    const [loading, setLoading] = useState(false);
    const [showDevName, setShowDevName] = useState(null);//选中的主机名
    const [selDevOptions, setSelDevOptions] = useState([]);//区域主机选项
    const [devFliters, setDevFliters] = useState([]);//所有主机选项
    const [dis, setDis] = useState('');
    const [isHumi, setIsHumi] = useState(false);
    const [selNode, setSelNode] = useState([]);
    const [selNodeColums, setSelNodeColums] = useState([]);//多测点查询表格列显示内容
    const [selDevice, setSelDevice] = useState({});//已选择的测点

    const [startTime, setStartTime] = useState('')
    const [endTime, setEndTime] = useState('')
    const [data, setData] = useState([])//报表数据
    const [dataP, setDataP] = useState([])
    const [dataF, setDataF] = useState({ tmin: 0, tmax: 0, tavg: 0, hmin: 0, hmax: 0, havg: 0 })//查询设备的最大 最小 平均值
    const [dataChart, setdataChart] = useState([])//直线图数据
    const [nodeFliters, setNodeFliters] = useState([]);
    const [selNodes, setSelNodes] = useState([]);
    const [showNodeName, setShowNodeName] = useState([]);
    const [interval,setInterval] = useState(0);
    const [userName,setUserName] = useState('');
    const [localCompany,setLocalCompany] = useState('');//本地公司名称
    const [dateTime,setDateTime] = useState('');//周期报表时间
    const [startWeek,setStartWeek] = useState('');//周报表开始时间
    const [endWeek,setEndWeek] = useState('');//周报表结束时间
    const [monthTime,setMonthTime] = useState('');//月报表时间
    const [AMTimes,setAMTimes] = useState([9]);//报表每日上午时间点
    const [PMTimes,setPMTimes] = useState([15]);//报表每日上午时间点
    const [tableType,setTableType] = useState(0);//报表类型 0普通历史数据  1日报表  2周报表 3月报表
    const [selNodeType,setSelNodeType] = useState(201);//设备主机类型  类型不同单位显示不同
    const [seriesTempData,setSeriesTempData] = useState([]);
    const [tempChart,setTempChart] = useState(undefined);
    const [dataWainF, setDataWainF] = useState({ tl: 0, th: 0,  hl: 0, hh: 0 })
    const [showBound,setShowBound] = useState(false);
    const [isEmpty,setIsEmpty] = useState(false);
    const [selDevs,setSelDevs] = useState([]);
    const [recordCount,setRecordCount] = useState('');//记录条数
    const [tabKey,setTabKey] = useState("1")
    const [tableCurrent,setTableCurrent] = useState(1)
    const [tablePageSize,setTablePageSize] = useState(10)
    const [isExportHumi,setIsExportHumi] = useState(true);
    const [showBoundWarnT,setShowBoundWarnT] = useState(false);
    const [showBoundWarnH,setShowBoundWarnH] = useState(false);
    const [dataWarnT,setDataWarnT] = useState({tl:0,th:0});
    const [dataWarnH,setDataWarnH] = useState({hl:0,hh:0});
    const [showHisModeNew,setShowHisModeNew] = useState(false)
    const [myChartP,setMyChartP] = useState()
    const [showHisLimit,setShowHisLimit] = useState(false)
    const [hisType,setHisType] = useState(0);
    useEffect(() => {
        let today =  new Date().setHours(0,0,0);
        todayTime = new Date(today).getTime();
        http.get("/v1/district", {}).then(data => {
            if (data.code === 0) {
                dispatch({ type: 'district', district: data.data });
            }
        })
        http.get("/v1/users", {}).then(data => {
            if (data.code === 0) {
                dispatch({ type: 'systemuser', systemuser: data.data.sort((a,b)=>a.name.localeCompare(b.name,'zh')) });
            }
        })
        http.get("/v1/userdistricts", {}).then(data => {
            if (data.code === 0) {
                dispatch({ type: 'user_district', user_district: data.data });
            }
        })
        http.get("/v1/device", {}).then(data => {
            if (data.code === 0) {
                dispatch({ type: 'device', device: data.data });
                let arrNode = new Array();
                let arrDev = new Array();
                data.data.filter(x=>x.node>0).sort((a, b) => a.sn - b.sn).map(m => {
                    arrNode.push({ label: m.name+'-'+m.sn, value: m.id, sn: m.sn ,expire:m.expire});
                    arrDev.findIndex(x => x.value === m.sn) === -1 && arrDev.push({ label: m.m_name+'-'+m.sn, value: m.sn ,expire:m.expire});
                })
                setDevFliters(arrDev);
                setNodeFliters(arrNode);
                setSelNodes(arrNode);
                setSelDevOptions(Mode==='soc'?arrDev.filter(x=>new Date(x.expire).getTime()>todayTime):arrDev);
            }
        })
        http.get("/v1/devicestatus", {}).then(data => {
            if (data.code === 0) {
              if (data.data !== null) { 
                dispatch_device({ type: 'devicestate', devicestate: data.data });
               }
            }
          })
        window.addEventListener('resize',()=>{
            setTimeout(() => {
                tempChart&&tempChart.resize();
                tempChart&&tempChart.setOption(option);
            }, 500);
        })
    }, []);
    useEffect(()=>{
        let todo = state.mainTodo;
        let todoCon = todo===''?null:JSON.parse(todo)
        setShowHisModeNew(todoCon?.showHisModeNew?true:false)
        setShowHisLimit(todoCon?.showHisLimit===undefined?true:todoCon.showHisLimit)
    },[state.mainTodo])
    useEffect(()=>{
        tempChart&& option && tempChart.setOption(option);
    },[seriesTempData,showBound,selNodeType])
    //报表查询上午时间选项
    const AMOptions=[
        {label:'0点',value:0},
        {label:'1点',value:1},
        {label:'2点',value:2},
        {label:'3点',value:3},
        {label:'4点',value:4},
        {label:'5点',value:5},
        {label:'6点',value:6},
        {label:'7点',value:7},
        {label:'8点',value:8},
        {label:'9点',value:9},
        {label:'10点',value:10},
        {label:'11点',value:11},
    ];
    //报表查询下午时间选项
    const PMOptions=[
        {label:'12点',value:12},
        {label:'13点',value:13},
        {label:'14点',value:14},
        {label:'15点',value:15},
        {label:'16点',value:16},
        {label:'17点',value:17},
        {label:'18点',value:18},
        {label:'19点',value:19},
        {label:'20点',value:20},
        {label:'21点',value:21},
        {label:'22点',value:22},
        {label:'23点',value:23},
    ]
    const option = {
        tooltip: {
            trigger: 'axis',
        },
        title: {
            left: 'center',
            text:isHumi?`${userName}\n${startTime}-${endTime}曲线图 \n 温度最小值${dataF.tmin}温度最大值${dataF.tmax}湿度最小值${dataF.hmin}湿度最大值${dataF.hmax}`:`${userName}\n${startTime}-${endTime}曲线图 \n 温度最小值${dataF.tmin}温度最大值${dataF.tmax}`
          },
        legend:{
            top:80,
            type:'scroll',
        },
        xAxis: {
            type: 'time',
            axisLabel:{
                formatter:'{HH}:{mm}:{ss} \n {yy}-{MM}-{dd} '
            },
            min:startTime,
            max:endTime
        },
        yAxis: {
            type: 'value',

            min: function (value) {
                return value.min.toFixed(1) - 2;
            },
            max : function (value) {
                return value.max.toFixed(1) +2;
            },      
            axisLabel:{
                formatter:function (value, index) {
                    return value.toFixed(1) ;
                }
            }
        },
        grid:
        {
            left:50,
            right:0,
            bottom:0,
            top:120,
            containLabel:true
        },
        // dataZoom: [
        //   {
        //     type: 'inside',
        //     start: 0,
        //     end: 20
        //   },
        //   {
        //     start: 0,
        //     end: 20
        //   }
        // ],
        series: seriesTempData,
    };   
    const configtemp = {
        data: dataChart.filter(x=>x.node!==0),
        padding: 'auto',
        xField: 'data_time',
        // height: 200,
        autoFit:true,
        yField: 'temp',
        seriesField: 'name',
        yAxis: {
            label: {
                formatter: function formatter(v) {
                    var i = v.indexOf('.');
                    return i===-1?v:v.slice(0,i+2);
                },
            },
            // tickCount:10
            max:(isEmpty||dataF.tmax> dataWainF.th)?dataF.tmax+2:dataWainF.th+2,
            min:!isEmpty&&dataWainF.tl<dataF.tmin?dataWainF.tl-2:dataF.tmin-2,
        },
        
        xAxis:{
            label:{
                offset:20
            }
        },
        slider: {
            start: 0,
            end:1,
            backgroundStyle:{
                fill: 'white',
                fillOpacity: 0,
                columnStyle: {
                    fill: 'white',
                    fillOpacity: 0,
                }
            },
            foregroundStyle:{
                fill: 'white',
                fillOpacity: 0,
            },
            trendCfg:{
                lineStyle:{stroke:'white'}
            }
        },
        annotations:showBound?showBoundWarnT? [
            {
                type: 'line',
                start: ['start',dataWainF.th],
                end:['end',dataWainF.th],
                style: {
                  stroke: '#F4664A',
                  lineDash: [5, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWainF.th],
                content: `${dataWainF.th+(selNodeType===205?'Pa':(selNodeType===210||selNodeType===211)?'MPa':'℃')}(上)`,
                offsetY: -4,
                offsetX:-14,
                style: {
                  textBaseline: 'bottom',
                },
            },
            {
                type: 'line',
                start: ['start',dataWarnT.th],
                end:['end',dataWarnT.th],
                style: {
                  stroke: '#FFA500',
                  lineDash: [8, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWarnT.th],
                content: `${dataWarnT.th+(selNodeType===205?'Pa':(selNodeType===210||selNodeType===211)?'MPa':'℃')}(上)`,
                offsetY: -4,
                offsetX:-14,
                style: {
                  textBaseline: 'bottom',
                },
            },
            {
                type: 'line',
                start: ['start',dataWainF.tl],
                end:['end',dataWainF.tl],
                style: {
                  stroke: '#F4664A',
                  lineDash: [5, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWainF.tl],
                content: `${dataWainF.tl+(selNodeType===205?'Pa':(selNodeType===210||selNodeType===211)?'MPa':'℃')}(下)`,
                offsetY: 18,
                offsetX:-14,
                style: {
                  textBaseline: 'bottom',
                },
            },
            {
                type: 'line',
                start: ['start',dataWarnT.tl],
                end:['end',dataWarnT.tl],
                style: {
                  stroke: '#FFA500',
                  lineDash: [8, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWarnT.tl],
                content: `${dataWarnT.tl+(selNodeType===205?'Pa':(selNodeType===210||selNodeType===211)?'MPa':'℃')}(下)`,
                offsetY: -4,
                offsetX:-14,
                style: {
                  textBaseline: 'bottom',
                },
            },
        ]:[
            {
                type: 'line',
                start: ['start',dataWainF.th],
                end:['end',dataWainF.th],
                style: {
                  stroke: '#F4664A',
                  lineDash: [5, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWainF.th],
                content: `${dataWainF.th+(selNodeType===205?'Pa':(selNodeType===210||selNodeType===211)?'MPa':'℃')}(上)`,
                offsetY: -4,
                offsetX:-14,
                style: {
                  textBaseline: 'bottom',
                },
            },
            {
                type: 'line',
                start: ['start',dataWainF.tl],
                end:['end',dataWainF.tl],
                style: {
                  stroke: '#F4664A',
                  lineDash: [5, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWainF.tl],
                content: `${dataWainF.tl+(selNodeType===205?'Pa':(selNodeType===210||selNodeType===211)?'MPa':'℃')}(下)`,
                offsetY: 18,
                offsetX:-14,
                style: {
                  textBaseline: 'bottom',
                },
            },
        ]:[],
        // color: '#D62A0D',
        color: ['#00bc12','#D62A0D', '#9900FF', '#000000','#335541','#656485','#784512','#255454','#621532','#785423','#996655','#996699','#9999CC','#99CC99','#99FFFF'],
    };
    const confighumi = {
        data: dataChart.filter(x=>x.node!==0),
        padding: 'auto',
        xField: 'data_time',
        // height: 200,
        autoFit:true,
        yField: 'humi',
        seriesField: 'name',
        yAxis: {
            label: {
                formatter: function formatter(v) {
                    var i = v.indexOf('.');
                    return i===-1?v:v.slice(0,i+2);
                },
            },
            // tickCount:10
            max:(!isEmpty&&dataWainF.hh>dataF.hmax)?(dataWainF.hh>97?100:dataWainF.hh+2):(dataF.hmax>97?100:dataF.hmax+2),
            min:(!isEmpty&&dataWainF.hl<dataF.hmin)?(dataWainF.hl<3?0:dataWainF.hl-2):(dataF.hmin<3?0:dataF.hmin-2),
        },
        xAxis: {
            label: {
                offset:20
            },
        },
        slider: {
            start: 0,
            end:1,
            backgroundStyle:{
                fill: 'white',
                fillOpacity: 0,
                columnStyle: {
                    fill: 'white',
                    fillOpacity: 0,
                }
            },
            foregroundStyle:{
                fill: 'white',
                fillOpacity: 0,
            },
            trendCfg:{
                lineStyle:{stroke:'white'}
            }
        },
        annotations: showBound?showBoundWarnH?[
            {
                type: 'line',
                start: ['start',dataWainF.hh],
                end:['end',dataWainF.hh],
                style: {
                  stroke: '#F4664A',
                  lineDash: [5, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWainF.hh],
                content: dataWainF.hh+'(上)',
                offsetY: -4,
                offsetX: -18,
                style: {
                  textBaseline: 'bottom',
                },
            },
            {
                type: 'line',
                start: ['start',dataWarnH.hh],
                end:['end',dataWarnH.hh],
                style: {
                  stroke: '#FFA500',
                  lineDash: [8, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWarnH.hh],
                content: dataWarnH.hh+'(上)',
                offsetY: -4,
                offsetX: -18,
                style: {
                  textBaseline: 'bottom',
                },
            },
            {
                type: 'line',
                start: ['start',dataWainF.hl],
                end:['end',dataWainF.hl],
                style: {
                  stroke: '#F4664A',
                  lineDash: [5, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWainF.hl],
                content: dataWainF.hl+'(下)',
                offsetY: 18,
                offsetX: -18,
                style: {
                  textBaseline: 'bottom',
                },
            },
            {
                type: 'line',
                start: ['start',dataWarnH.hl],
                end:['end',dataWarnH.hl],
                style: {
                  stroke: '#FFA500',
                  lineDash: [8, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWarnH.hl],
                content: dataWarnH.hl+'(下)',
                offsetY: -4,
                offsetX: -18,
                style: {
                  textBaseline: 'bottom',
                },
            },
        ]:[
            {
                type: 'line',
                start: ['start',dataWainF.hh],
                end:['end',dataWainF.hh],
                style: {
                  stroke: '#F4664A',
                  lineDash: [5, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWainF.hh],
                content: dataWainF.hh+'(上)',
                offsetY: -4,
                offsetX: -18,
                style: {
                  textBaseline: 'bottom',
                },
            },
            {
                type: 'line',
                start: ['start',dataWainF.hl],
                end:['end',dataWainF.hl],
                style: {
                  stroke: '#F4664A',
                  lineDash: [5, 4],
                },
            },
            {
                type: 'text',
                position: ['min', dataWainF.hl],
                content: dataWainF.hl+'(下)',
                offsetY: 18,
                offsetX: -18,
                style: {
                  textBaseline: 'bottom',
                },
            },
        ]:[]
        ,
        // color: '#1979C9',
    };
    const columnsLeft = [
        {
            title:'记录条数:'+recordCount,
            children:[
                {
                    title: '时间',
                    dataIndex: 'data_time',
                    align: 'center  ',
                    width: 160,
                    fixed: true,
                    sorter: (a, b) =>new Date(a.data_time).getTime()  -new Date(b.data_time).getTime() ,
                }
            ]
        },
    ]
    const columnsRight = [

        {
            title: '信号',
            dataIndex: 'csq',
            key: 'id',
            align: 'center',
            width: 80,
        },
        {
            title: '电源',
            dataIndex: 'power',
            key: 'id',
            align: 'center',
            width: 80,
            render: (text, record) => (
                <div>{record.power === 0 ? "正常" : "电池"}</div>
            )
        },
        {
            title: '电量',
            dataIndex: 'battery',
            key: 'id',
            align: 'center',
            width: 80,
        },
    ]
    if (Mode==='soc') {
        //登录用户是普通用户
        if(state.main.type===104){
            const ud = state.district;
            userdistrictlist = new Array();
            ud.map(item => {
                var u = new Object;
                u.key = item.id;
                u.title = item.name;
                u.label = item.name;
                u.text = item.name;
                u.value =item.id;
                u.name = item.name;
                // u.id = item.id
                userdistrictlist.unshift(u);
            })
        }else if(state.systemuser.treeM){
            userdistrictlist = JSON.parse(JSON.stringify(state.systemuser.treeM));
            if (userdistrictlist && userdistrictlist.length > 0) {
                 addUserDistrict(userdistrictlist);
            } 
        }
    }
    if (Mode!=='soc' && state.district) {
        userdistrictlist = new Array();
        state.district.map(item => {
            var u = new Object;
            u.key = item.id;
            u.title = item.name;
            u.label = item.name;
            u.text = item.name;
            u.value = item.id;
            u.name = item.name;
            // u.id = item.id
            userdistrictlist.push(u);
        })

    }
    function addUserDistrict(userlist) {
        for (var i = 0; i < userlist.length; i++) {
            if (!userlist[i].children) {
                let ud=[];
                userlist[i].id&& (ud = state.district.filter(x => x.user == userlist[i].id));//筛查userlist[i]创建的所有区域
                if (ud.length > 0) {
                    userlist[i].children = [];
                    ud.map(item => {
                        var u = new Object;
                        u.key = item.id;
                        u.title = item.name;
                        u.label = item.name;
                        u.text = item.name;
                        u.value = 'dis'+item.id;
                        u.name = item.name;
                        userlist[i].children.unshift(u);
                    })
                }
                else{
                    userlist[i].id&&(userlist.splice(i,1));
                    // userlist[i].id&&(userlist[i].disabled=true);
                }
            } else {
                let ud=[];
                userlist[i].id&& (ud = state.district.filter(x => x.user == userlist[i].id));//筛查userlist[i]创建的所有区域
                if (ud.length > 0) {
                    ud.map(item => {
                        var u = new Object;
                        u.key = item.id;
                        u.title = item.name;
                        u.label = item.name;
                        u.text = item.name;
                        u.value = 'dis'+item.id;
                        u.name = item.name;
                        // u.id = item.id
                        userlist[i].children.unshift(u);
                    })
                }
                addUserDistrict(userlist[i].children);
            }
        }
    }
    
    const showMyChart = (val='',title='')   =>{
        setTimeout(() => {
            let chartDom = document.getElementById('tempEcharts');
            if(chartDom){
                let myChart = echarts.init(chartDom);
                setMyChartP(myChart)
                if(val!==''){
                    option.series = val
                    option.title = title
                }
                option && myChart.setOption(option);
                myChart.resize();
                myChart&&setTempChart(myChart);
                myChart&&myChart.dispatchAction({
                    type: 'legendScroll',
                    scrollDataIndex: 5,
                    // legendId: string
                })
            }    
        }, 500);
    }
    const onChange_Tab = key => {
        setTabKey(key)
        if (key==='2'){
            showMyChart()
        }else if((key==='3'||key==='4')){
            if(hisType>0){
                let tmax = dataChart.map(o=>o.temp).reduce((a,b)=>Math.max(a,b));
                let tmin = dataChart.map(o=>o.temp).reduce((a,b)=>Math.min(a,b));
                let hmax =0;
                let hmin =0;
                if(isHumi){
                    hmax = dataChart.map(o=>o.humi).reduce((a,b)=>Math.max(a,b));
                    hmin = dataChart.map(o=>o.humi).reduce((a,b)=>Math.min(a,b));
                }
                setDataF({tmin,tmax,tavg:0,hmin,hmax,havg:0})
            }
            
            tempChart&&tempChart.dispose();
        }
    };
    const onChange_Table = (page,pageSize) =>{
        setTableCurrent(page)
        setTablePageSize(pageSize)
    }
    const antdPointClick =(plot) => {
        plot.on('element:click', args => {
         const {x,y} = args
         let points = args.data.points;
         // let data = args.data.data;
         points = points.reverse()
         let ele = points.reduce((prec,cur)=>{
             let xLen = Math.abs(prec.x-x);
             let xLen1 = Math.abs(cur.x-x);
             let yLen = Math.abs(prec.y-y);
             let yLen1 = Math.abs(cur.y-y);
             if(Math.sqrt(xLen*xLen+yLen*yLen)<Math.sqrt(xLen1*xLen1+yLen1*yLen1)){
                 return prec
             }else{
                 return cur
             }
         });
         let index = points.findIndex(val=>val.x===ele.x&&val.y===ele.y)
         setTabKey('1');
         setTableCurrent(Math.ceil(index/tablePageSize))
       });
     }

    const exportPDF =(type=0)=>{
        let now_date = new Date(); now_date.setHours(0); now_date.setMinutes(0); now_date.setSeconds(0);
        let url = "/v1/"
        let time ='';
        AMTimes.map(item=>item<10?time+=('0'+item+':00:00,'):time+=(item+':00:00,'));
        PMTimes.map(item=>time+=(item+':00:00,'));
        time=time.slice(0,-1);
        //普通报表下载
        if(tableType===0)
        {
            if(type!==0){
                url += "historydpdf?device=" + selDevice.sn + "&node=" + selNode + "&starttime=" ;
                startTime===''?url+= formatDateTimes(now_date.getTime()) + "&endtime=" + formatDateTimes(new Date().getTime()):
                endTime===''? url+=startTime+"&endtime=" + formatDateTimes(new Date().getTime()):
                url+=startTime+"&endtime=" + endTime;
                url+="&min="+interval;
                url+='&power=false&door=false'
            }else{
                if(selDevice.type===214){
                    url += "historydwpdf?device=" + selDevice.sn + "&node=" + selNode + "&starttime=" ;
                    startTime===''?url+= formatDateTimes(now_date.getTime()) + "&endtime=" + formatDateTimes(new Date().getTime()):
                    endTime===''? url+=startTime+"&endtime=" + formatDateTimes(new Date().getTime()):
                    url+=startTime+"&endtime=" + endTime;
                    url+="&min="+interval;
                }else{
                    showHisModeNew?
                    url += "historydapdf?device=" + selDevice.sn + "&node=" +  selNode + "&starttime=":
                    url += "historydpdf?device=" + selDevice.sn + "&node=" + selNode + "&starttime=" ;
                    startTime===''?url+= formatDateTimes(now_date.getTime()) + "&endtime=" + formatDateTimes(new Date().getTime()):
                    endTime===''? url+=startTime+"&endtime=" + formatDateTimes(new Date().getTime()):
                    url+=startTime+"&endtime=" + endTime;
                    url+="&min="+interval;
                }
            }
            
        }
        //月报表下载
        if(tableType===3){
            url+="historymondpdf?device=" +selDevice.sn + "&node=" + selNode+ "&time=" + time+ '&mon='+monthTime;
            if (type!==0) url+='&power=false&door=false'
        }
        //周报表下载
        if(tableType===2||tableType===1){
            url+="historyweekdpdf?device="+selDevice.sn + "&node=" + selNode+ "&time=" + time +'&starttime='+startWeek+'&endtime=';
            url+=endWeek===''?formatDateTimes(new Date().getTime()):endWeek;
            if (type!==0) url+='&power=false&door=false'
        }
        
        if(!isExportHumi){
            url+="&humi=false"
        };
        url+=""
        if(Mode==='soc'){
            fetch(url, { //downloadFiles 接口请求地址
                method: 'get',
                credentials: 'include',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                })
            })
            .then((response) => {
                response.blob().then(blob => {
                    let blobUrl = window.URL.createObjectURL(blob);
                    let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                    let filename = selDevice.m_name + '.pdf';//设置文件名称
                    aElement.href = blobUrl;//设置a标签路径
                    aElement.download = filename;
                    aElement.click();
                    window.URL.revokeObjectURL(blobUrl);
                });
            }).catch((error) => {
                console.log('文件下载失败', error);
            });
        }else{

            if(window.CefSharp!==undefined){
                window.CefSharp.BindObjectAsync("bound");
                let path = window.bound.exportPDF(selDevice.m_name + '.pdf');
                url+="&path=" + path;
                http.get(url, {}).then(data=>{
                    if(data.code===0&&data.msg==="ok")message.success('PDF导出成功'+data.data,3);
                })
            }
        }
                                        
    }
    const exportExcel =(type=0)=>{
        var now_date = new Date(); now_date.setHours(0); now_date.setMinutes(0); now_date.setSeconds(0);
        let url = "/v1/"
        let time ='';
        AMTimes.map(item=>item<10?time+=('0'+item+':00:00,'):time+=(item+':00:00,'));
        PMTimes.map(item=>time+=(item+':00:00,'));
        time=time.slice(0,-1);
        //普通报表下载
        if(tableType===0)
        {
            if(type!==0){
                url += "historydliteexcel?device=" +selDevice.sn + "&node=" + selNode;
            }else{
                url+="historydexcel?device=" +selDevice.sn + "&node=" + selNode;
            }
            startTime===''?url+= "&starttime=" + formatDateTimes(now_date.getTime()) + "&endtime=" + formatDateTimes(new Date().getTime()):
            endTime===''? url+="&starttime=" + startTime+"&endtime=" + formatDateTimes(new Date().getTime()):
            url+="&starttime=" + startTime+"&endtime=" + endTime;
            url+="&min="+interval;
        }
        //月报表下载
        if(tableType===3){
            url+="historymondexcel?device=" +selDevice.sn + "&node=" + selNode+ "&time=" + time+ '&mon='+monthTime;
        }
        //周,日报表下载
        if(tableType===2||tableType===1){
            url+="historyweekdexcel?device="+selDevice.sn + "&node=" + selNode+ "&time=" + time +'&starttime='+startWeek+'&endtime=';
            url+=endWeek===''?formatDateTimes(new Date().getTime()):endWeek;
        }
        if(Mode==='soc'){
            fetch(url, { //downloadFiles 接口请求地址
                method: 'get',
                credentials: 'include',
                headers: new Headers({
                    'Content-Type': 'application/json',
                    'Authorization': `Bearer ${localStorage.getItem('token')}`
                })
            })
            .then((response) => {
                response.blob().then(blob => {
                    let blobUrl = window.URL.createObjectURL(blob);
                    let aElement = document.getElementById('downloadDiv'); //获取a标签元素
                    let filename = selDevice.name + '.xlsx';//设置文件名称
                    aElement.href = blobUrl;//设置a标签路径
                    aElement.download = filename;
                    aElement.click();
                    window.URL.revokeObjectURL(blobUrl);
                });
            }).catch((error) => {
                console.log('文件下载失败', error);
            });
        }else{
            if(window.CefSharp!==undefined){
                window.CefSharp.BindObjectAsync("bound");
                let path = window.bound.exportEXCEL(selDevice.m_name + '.pdf');
                url+="&path=" + path;
                http.get(url, {}).then(data=>{
                    if(data.code===0&&data.msg==="ok")message.success('EXCEL导出成功'+data.data,3);
                })
            }
        }
    }
    function getChartImage() {
        var imgUrl = myChartP&&myChartP.getDataURL({
            // 指定图片的宽度和高度
            pixelRatio: 0.8,
            backgroundColor: '#fff'
        });
        return imgUrl;
    }
    async function fetchAllData(url,nodes) {
        const promises = nodes.map(node =>{
            let urlTemp = url+"&node=" + node;
            return http.get(urlTemp,{})
        }
        );
        // 等待所有请求完成，确保结果顺序与urls一致
        return await Promise.all(promises);
    }
    async function getHisData(type=0) {
        
        //初始化
        setDataF({tmin: 0, tmax: 0, tavg: 0, hmin: 0, hmax: 0, havg: 0 });
        setdataChart([]);
        setData([]);
        setSeriesTempData([])
        if (selDevice.sn === undefined || selDevice.node === undefined) return message.warning('未选择设备');
        let isShowBoundWT = true
        let isShowBoundWH = true
        let selNodes= selNode.length>1?selNode.filter(x=>x!==0):selNode
        let devicestateTemp = state_device.devicestate.filter(x=>x.Sn===selDevice.sn&&selNodes.includes(x.Node))
        let fristdevice = devicestateTemp[0].Sensor;
        if(fristdevice.TempWarningLow===fristdevice.TempWarningHigh){
            isShowBoundWT = false
        }
        if(fristdevice.HumiWarningLow===fristdevice.HumiWarningHigh){
            isShowBoundWH = false
            
        }
        devicestateTemp.map(m=>{
            if(isShowBoundWT){
                if(m.Sensor.TempWarningHigh!==fristdevice.TempWarningHigh){
                    isShowBoundWT = false
                }
            }
            if(isShowBoundWH){
                if(m.Sensor.HumiWarningHigh!==fristdevice.HumiWarningHigh){
                    isShowBoundWH = false
                }
            }
            
        })
        setDataWarnT({tl:fristdevice.TempWarningLow,th:fristdevice.TempWarningHigh})
        setDataWarnH({tl:fristdevice.HumiWarningLow,th:fristdevice.HumiWarningHigh})
        setShowBoundWarnT(isShowBoundWT)
        setShowBoundWarnH(isShowBoundWH)
        let url = "/v1"; 
        let start = '';
        let end ='';
        // 普通报表
        if(tableType===0){
            var now_date = new Date(); now_date.setHours(0); now_date.setMinutes(0); now_date.setSeconds(0);
            startTime===''&&setStartTime(formatDateTimes(now_date.getTime()));
            endTime===''&&setEndTime(formatDateTimes(new Date().getTime()));
            start=startTime===''?formatDateTimes(now_date.getTime()):startTime;
            end=endTime===''? formatDateTimes(new Date().getTime()):endTime;
            url += "/history?device=" + selDevice.sn  + "&starttime=" ;
            url+=start+"&endtime=" + end;
            // startTime===''?url+= formatDateTimes(now_date.getTime()) + "&endtime=" + formatDateTimes(new Date().getTime()):
            // endTime===''? url+=startTime+"&endtime=" + formatDateTimes(new Date().getTime()):
            // url+=startTime+"&endtime=" + endTime;
        }else{
            // 周期报表
            if( tableType===3&&monthTime==='')return message.warning('未选择月份');
            if( tableType===2&&startWeek==='')return message.warning('未选择星期');
            if( tableType===1&&startWeek==='')return message.warning('未选择时间');
            let time ='';
            AMTimes.map(item=>item<10?time+=('0'+item+':00:00,'):time+=(item+':00:00,'));
            PMTimes.map(item=>time+=(item+':00:00,'));
            time=time.slice(0,-1);
            
            tableType===3?url+="/historymon?device=":url+="/historyweek?device=";
            url+=selDevice.sn  + "&time=" + time;
            tableType===3?url+=('&mon='+monthTime):endWeek!==''?url+='&starttime='+startWeek+'&endtime='+endWeek:
            url+='&starttime='+startWeek+'&endtime='+formatDateTimes(new Date().getTime());
        }
        url+="&min="+interval+"&node=" + selNodes ;
        setLoading(true);
        setIsHumi(false);
        // let dev_val=[]; 
        // let baseData=[];
        // let ar =[];
        // await fetchAllData(url,selNodes).then(ele => {
        //     setLoading(false);
        //     console.log('获取完成');
        //     ele.forEach(data => {
        //         if (data.data&&data.data.length > 0) {
        //             // let isHumi = false;
        //             // let sss= data.data.find(x=>x.humi_switch!==0&&x.humi_enable!==0);//查找是否有湿度数据
        //             // if(sss){
        //             //     setIsHumi(true);
        //             //     isHumi= true;
        //             // }
        //             let dataF =(showHisModeNew&&[201,208,212].includes(selDevice.type))?data.data.filter(x=>(+x.data_time.slice(-5,-3)%30===0)||x.temp>x.temp_h||x.temp<x.temp_l||x.humi>x.humi_h||x.humi<x.humi_l):data.data
        //             // let artemp = dataF.filter(item => item.temp !== 102.3 && item.temp !== 102.2 && item.node!==0&&item.temp_switch!==0
        //             //     &&item.temp !== -102.3 && item.temp !== -102.2 );
        //             // if(isHumi){
        //             //     artemp = artemp.filter(item => item.humi !== -102.2&&item.humi !== -102.3&&item.humi !== 102.3 && item.humi !== 102.2);
        //             // }
        //             // ar=[...ar,...artemp]
        //             const timeMap = new Map(baseData.map(x => [x.data_time, x]));
        //             dataF.forEach(m => {
        //                 // 通过哈希表快速定位 (替代find)
        //                 const existing = timeMap.get(m.data_time);

        //                 if (existing) {
        //                     // 批量赋值代替逐属性修改
        //                     const nodeSuffix = m.node;
        //                     const fields = {
        //                         temp: m.temp,
        //                         temp_h: m.temp_h,
        //                         temp_l: m.temp_l,
        //                         temp_alarm: m.temp_alarm,
        //                         temp_switch: m.temp_switch,
        //                         humi: m.humi,
        //                         humi_h: m.humi_h,
        //                         humi_l: m.humi_l,
        //                         humi_alarm: m.humi_alarm,
        //                         humi_switch: m.humi_switch,
        //                         humi_enable: m.humi_enable,
        //                         districtname: m.districtname,
        //                         door: m.door,
        //                         power: m.power,
        //                         battery: m.battery
        //                     };

        //                     Object.entries(fields).forEach(([key, val]) => {
        //                         existing[`${key}${nodeSuffix}`] = val;
        //                     });
        //                 } else {
        //                     // 创建新对象时一次性构建所有属性
        //                     const newNode = { data_time: m.data_time };
        //                     const nodeSuffix = m.node;

        //                     [
        //                         ['temp', m.temp],
        //                         ['temp_h', m.temp_h],
        //                         ['temp_l', m.temp_l],
        //                         ['temp_alarm', m.temp_alarm],
        //                         ['temp_switch', m.temp_switch],
        //                         ['humi', m.humi],
        //                         ['humi_h', m.humi_h],
        //                         ['humi_l', m.humi_l],
        //                         ['humi_alarm', m.humi_alarm],
        //                         ['humi_switch', m.humi_switch],
        //                         ['humi_enable', m.humi_enable],
        //                         ['districtname', m.districtname],
        //                         ['door', m.door],
        //                         ['power', m.power],
        //                         ['battery', m.battery]
        //                     ].forEach(([key, val]) => {
        //                         newNode[`${key}${nodeSuffix}`] = val;
        //                     });

        //                     timeMap.set(m.data_time, newNode);
        //                     baseData.push(newNode);
        //                 }
        //             });
    
        //             // let tmax = artemp[0]?.temp
        //             // let tmin = artemp[0]?.temp
        //             // let hmax = artemp[0]?.humi
        //             // let hmin = artemp[0]?.humi
        //             // let totalt = 0
        //             // let totalh = 0
        //             // artemp.forEach(item=>{
        //             //     if(item.temp>tmax){
        //             //         tmax = item.temp
        //             //     }
        //             //     if(item.temp<tmin){
        //             //         tmin = item.temp
        //             //     }
        //             //     if(item.humi>hmax){
        //             //         hmax = item.humi
        //             //     }
        //             //     if(item.humi<hmin){
        //             //         hmin = item.humi
        //             //     }
        //             //     totalt += item.temp
        //             //     totalh += item.humi
        //             // })
        //             // let count = artemp.length;
        //             // dev_val.push({node:data.data[0].node,temp_h:tmax,temp_l:tmin,humi_l:hmin,humi_h:hmax,temp_s:totalt/count,humi_s:totalh/count})
        //         }   
        //     })
        // });


        http.get(url,{}).then((data) => {
            setLoading(false);
            if (data.code === 0) {
                if (data.data===null||data.data.length === 0) return message.warning('暂无数据');
                
                let isHumi = false;
                let sss= data.data.find(x=>x.humi_switch!==0&&x.humi_enable!==0);//查找是否有湿度数据
                if(sss){
                    setIsHumi(true);
                    isHumi= true;
                }
                let dataF =(showHisModeNew&&[201,208,212].includes(selDevice.type))?data.data.filter(x=>(+x.data_time.slice(-5,-3)%30===0)||x.temp>x.temp_h||x.temp<x.temp_l||x.humi>x.humi_h||x.humi<x.humi_l):data.data
                
                if(type===0){
                    let dev_val=[]; 
                    let baseData=[];
                    const timeMap = new Map(baseData.map(x => [x.data_time, x]));
                    dataF.forEach(m => {
                        // 通过哈希表快速定位 (替代find)
                        const existing = timeMap.get(m.data_time);
    
                        if (existing) {
                            // 批量赋值代替逐属性修改
                            const nodeSuffix = m.node;
                            const fields = {
                                temp: m.temp,
                                temp_h: m.temp_h,
                                temp_l: m.temp_l,
                                temp_alarm: m.temp_alarm,
                                temp_switch: m.temp_switch,
                                humi: m.humi,
                                humi_h: m.humi_h,
                                humi_l: m.humi_l,
                                humi_alarm: m.humi_alarm,
                                humi_switch: m.humi_switch,
                                humi_enable: m.humi_enable,
                                districtname: m.districtname,
                                door: m.door,
                                power: m.power,
                                battery: m.battery
                            };
    
                            Object.entries(fields).forEach(([key, val]) => {
                                existing[`${key}${nodeSuffix}`] = val;
                            });
                        } else {
                            // 创建新对象时一次性构建所有属性
                            const newNode = { data_time: m.data_time };
                            const nodeSuffix = m.node;
    
                            [
                                ['temp', m.temp],
                                ['temp_h', m.temp_h],
                                ['temp_l', m.temp_l],
                                ['temp_alarm', m.temp_alarm],
                                ['temp_switch', m.temp_switch],
                                ['humi', m.humi],
                                ['humi_h', m.humi_h],
                                ['humi_l', m.humi_l],
                                ['humi_alarm', m.humi_alarm],
                                ['humi_switch', m.humi_switch],
                                ['humi_enable', m.humi_enable],
                                ['districtname', m.districtname],
                                ['door', m.door],
                                ['power', m.power],
                                ['battery', m.battery]
                            ].forEach(([key, val]) => {
                                newNode[`${key}${nodeSuffix}`] = val;
                                newNode[`${key}`]=val;
                            });
                            newNode.csq = m.csq; 
                            timeMap.set(m.data_time, newNode);
                            baseData.push(newNode);
                        }
                    });
                    setData(baseData.reverse());
                    setRecordCount(baseData.length+'');
                    
                    let ar = dataF.filter(item => item.temp !== 102.3 && item.temp !== 102.2 && item.node!==0&&item.temp_switch!==0
                        &&item.temp !== -102.3 && item.temp !== -102.2 );
                    if(isHumi){
                        ar = ar.filter(item => item.humi !== -102.2&&item.humi !== -102.3&&item.humi !== 102.3 && item.humi !== 102.2);
                    }
                    dataF = null;
                    let sd = selDevs.concat()
                    let nodeCol = new Array();
                    if(sd.length>1){
                        sd.sort((a,b)=>a.node-b.node);
                        if(sd[0].node===0){
                            let temp = sd.splice(0,1);
                            sd.push(temp[0]);
                        }
                    }
                    let seriesData=[]
                    let tmax =0;let tmin =0; let hmax =0;let hmin =0; let tavg =0; let havg =0; 
                    if (ar.length === 0) {
                        message.warning('暂无有效数据');
                    }else{
                        ar.sort((a,b)=>{
                            if(a.data_time===b.data_time){
                                return a.node-b.node;
                            }else{
                                return a.data_time-b.data_time;
                            }
                        }); 
                          
                        let isShowBound = true;                          
                        if(selNode.length>0){
    
                            tmax = ar.map(o=>o.temp).reduce((a,b)=>Math.max(a,b));
                            tmin = ar.map(o=>o.temp).reduce((a,b)=>Math.min(a,b));
                            hmax = ar.map(o=>o.humi).reduce((a,b)=>Math.max(a,b));
                            hmin = ar.map(o=>o.humi).reduce((a,b)=>Math.min(a,b));
                            let th =ar[0].temp_h;
                            let tl =ar[0].temp_l;
                            let hh = ar[0].humi_h;
                            let hl = ar[0].humi_l;
                            let isHumi =  ar[0].humi_enable&&ar[0].humi_switch
                            let deviceInfos = state_device.devicestate.filter(x=>x.Sn===selDevice.sn && selNode.includes(x.Node));
                            let deviceInfo = deviceInfos.filter(x=>x.Sensor.Hide!==2&&x.Sensor.Hide!==3 );
                            let deviceInfoHide = deviceInfos.filter(x=>x.Sensor.Hide===2||x.Sensor.Hide===3 );
                            if(deviceInfo.length>0){ 
                            }
                            else{
                                if (deviceInfoHide.length>0){
                                    setIsEmpty(true)
                                }
                            }
                            const nodeMap = new Map(dev_val.map(x => [x.node, x]));
                            ar.map(item => {
                                if(isShowBound){
                                    if(item.temp_l!==tl||item.temp_h!==th){
                                        isShowBound = false
                                        th =0;
                                        tl =0;
                                        hh = 0;
                                        hl = 0;
                                    }else{
                                        if(isHumi&&(item.humi_h!==hh||item.humi_l!==hl)){
                                            isShowBound = false
                                            th =0;
                                            tl =0;
                                            hh = 0;
                                            hl = 0;
                                        }
                                    }
                                    
                                }
                                const existing = nodeMap.get(item.node);
                                if(!existing){
                                    const newNode = {node:item.node,temp_h:item.temp,temp_l:item.temp,humi_l:item.humi,humi_h:item.humi,temp_s:item.temp,humi_s:item.humi,count:1};
                                    nodeMap.set(item.node, newNode);
                                    dev_val.push(newNode)
                                }else{
                                    existing.temp_s +=item.temp; 
                                    existing.humi_s +=item.humi; 
                                    existing.count +=1; 
                                    if(item.temp>existing.temp_h){
                                        existing.temp_h = item.temp
                                    }
                                    if(item.temp<existing.temp_l){
                                        existing.temp_l = item.temp
                                    }
                                    if(item.humi>existing.humi_h){
                                        existing.humi_h = item.humi
                                    }
                                    if(item.humi<existing.humi_l){
                                        existing.humi_l = item.humi
                                    }
                                }
                                tavg = tavg + item.temp;
                                
                                havg = havg + item.humi;
                            })
                            dev_val.map(item=>{
                                item.temp_s = item.temp_s/item.count
                                item.humi_s = item.humi_s/item.count
                            })
                            // setValStatistical(dev_val);
                            tavg = tavg / ar.length;
                            havg = havg / ar.length;
                            setDataF({ tmax, tmin, tavg, hmin, hmax, havg });
                            setDataWainF({th,tl,hh,hl});
                            setShowBound(isShowBound)
                        }
                        
                        setdataChart(ar);
                        start =  ar[0];
                        end = ar[ar.length-1];
    
                        
                        selNode.map(item=>{
                            let tempdata =[];
                            let humidata =[];
                            let name ='';
                            ar.filter(x=>x.node ==item).map(val=>{
                                tempdata.push([val.data_time,val.temp]);
                                humidata.push([val.data_time,val.humi]);
                                if(name==='' ){
                                    name =val.name
                                }
                            })
                            start.data_time!==startTime&&tempdata.unshift(null);
                            end.data_time!==endTime&&tempdata.push(null);
                            seriesData.push({
                                'name':name+'温度曲线',
                                type: 'line',
                                smooth: true,
                                symbol: 'none',
                                data: tempdata,
                            })
                            isHumi&&seriesData.push({
                                'name':name+'湿度曲线',
                                type: 'line',
                                smooth: true,
                                symbol: 'none',
                                data: humidata,
                            })
                        })
                        if(selNode.length===1){
                            setDataP(JSON.parse(JSON.stringify(baseData)))
                        }
                        setSeriesTempData(seriesData);
                        
                    }
                    
                    sd.map(({ node, name, district_name, m_name,id,door_alarm ,type,humi}) => {
                        if (node!==0){
                            let devNode= dev_val.filter(x=>x.node===node);
                            let obj ={
                                title: `${name}-(区域:${district_name}-主机:${m_name}-测点ID:${node})`,
                                align: 'center',
                                children: [
                                    {
                                        title: `温度 (最大:${devNode.length>0?devNode[0].temp_h.toFixed(1):''} 
                                            最小:${devNode.length>0?devNode[0].temp_l.toFixed(1):''} 
                                            平均:${devNode.length>0?devNode[0].temp_s.toFixed(1):''})`,
                                        align: 'center',
                                        children:[
                                            
                                            {
                                                title: '温度(℃)',
                                                dataIndex: 'temp' + node,
                                                align: 'center',
                                                width:100,
                                                render: (text, record) => (
                                                    <div>
                                                        <div style={{color:record['temp_alarm' + node] === 1 ?'red':''}}>{ record['temp_switch' + node] === 0 ? "--" : text?
                                                        (text === 102.2||text === 102.3||text === -102.2||text === -102.3) ? " NL" :text.toFixed(1):''}</div>
                                                    </div>
                                                )
                                            },
                                            {
                                                title: '状态',
                                                dataIndex: 'temp_alarm' + node,
                                                align: 'center',
                                                width: 60,
                                                render: (text, record) => (
                                                    <div style={{color:text === 1 ?'red':''}}>{record['temp_switch' + node] === 0 ? "--" :text === 0 ? '正常' :text === 1 ? '报警':null}</div>
                                                )
                                            },
                                        ]
                                    }
                                ]
                            }
                            if(showHisLimit){
                                obj.children[0].children.unshift(
                                    {
                                        title: '上下限(℃)',
                                        dataIndex: 'temp_h' + node,
                                        align: 'center',
                                        width:100,
                                        render: (text, record) => (
                                            <div>
                                                {record['temp_switch' + node] === 0 ? null :text===undefined?'': <div>{`${text}~${record['temp_l' + node]}`}</div>}
                                            </div>
                                        )
                                    },
                                )
                            }
                            if (humi!==0){
                                obj.children.push({
                                    title: `湿度 (最大:${devNode.length>0?devNode[0].humi_h:''} 
                                        最小:${devNode.length>0?devNode[0].humi_l:''} 
                                        平均:${devNode.length>0?devNode[0].humi_s.toFixed(1):''})`,
                                    align: 'center',
                                    children:[
                                        {
                                            title: '湿度(%RH)',
                                            dataIndex: 'humi' + node,
                                            align: 'center',
                                            width: 100,
                                            render: (text, record) => (
                                                <div>
                                                    <div style={{color:record['humi_alarm' + node] === 1 ?'red':''}}>{ record['humi_switch' + node] === 0 ? "--" : record['humi_enable' + node]===0 ?"--":
                                                    (text === 102.2||text === 102.3||text === -102.2||text === -102.3) ? " NL" : text?text.toFixed(1):''}</div>
                                                </div>
                                            )
                                        },
                                        {
                                            title: '状态',
                                            dataIndex: 'humi_alarm' + node,
                                            width: 60,
                                            align: 'center',
                                            render: (text, record) => (
                                                <div style={{color:text === 1 ?'red':''}}>{record['humi_switch' + node] === 0 ? "--" : record['humi_enable' + node]===0 ?"--" :text === 0 ? '正常' : text === 1 ? '报警':''}</div>
                                            )
                                        },
                                    ]
                                },)
                                if(showHisLimit){
                                    obj.children[1].children.unshift(
                                        {
                                            title: '上下限(%RH)',
                                            dataIndex: 'humi_h' + node,
                                            align: 'center',
                                            width: 100,
                                            render: (text, record) => (
                                                <div>
                                                    {record['humi_switch' + node] === 0 || record['humi_enable' + node]===0 ? null : text?<div>{`${text}~${record['humi_l' + node]}`}</div>:''}
                                                </div>
                                            )
                                        },
                                    )
                                }
                            }
                            if(selDevice.type===214){
                                obj.children.push( {
                                    title: '门状态',
                                    align: 'center',
                                    dataIndex:'door'+node,
                                    width:80,
                                    render:(text,record)=>{
                                        return <div style={{color:text===1?'red':'black'}}>{text===1?'门开启':text===0?'门关闭':''}</div>
                                    }
                                })
                            }
                            if(selDevice.type===214||selDevice.type===208){
                                obj.children.push( 
                                {
                                    title: '电量',
                                    align: 'center',
                                    width:60,
                                    dataIndex:'battery'+node
                                }
                            )}
                            nodeCol.push(obj)   
                        }else{
                            door_alarm===1 &&
                            nodeCol.push({
                                title: '门状态',
                                dataIndex: 'door' + node,
                                width: 100,
                                align: 'center',
                                render: (text, record) => (
                                    <div>
                                        <div>{record['door' + node]  === 0 ? "关门" : '开门'}</div>
                                    </div>
                                )
                            })
                        }
                    })
                    if(selDevice.type!==214){
                        nodeCol.push( 
                            {
                                title: '信号',
                                dataIndex: 'csq',
                                align: 'center',
                                width: 80,
                            },
                            {
                                title: '电源',
                                dataIndex: selDevice.type===208?'power0':'power',
                                align: 'center',
                                width: 80,
                                render: (text, record) => (
                                    <div>{text === 0 ? "正常" : text === 1?"电池":''}</div>
                                )
                            },
                            {
                                title: '电量',
                                dataIndex: selDevice.type===208?'battery0':'battery',
                                key: 'id',
                                align: 'center',
                                width: 80,
                            },)
                    }
                    setSelNodeColums(nodeCol)
                    if(tabKey==='2'){
                        let title={
                            left: 'center',
                            text:isHumi?`${userName}\n${startTime}-${endTime}曲线图 \n 温度最小值${tmin}温度最大值${tmax}湿度最小值${hmin}湿度最大值${hmax}`:`${userName}\n${startTime}-${endTime}曲线图 \n 温度最小值${tmin}温度最大值${tmax}`
                          }
                        showMyChart(seriesData,title)
                    }                   
                }else{
                    setTabKey("1")
                    dataF = dataF.filter(x=>x.node!==0)
                    const createFilter = (keys) => new Proxy({}, {
                        get: (target, prop) => keys.includes(prop)
                      });
                      
                      const dynamicFilter = createFilter(['id', 'name','node','temp','humi','data_time']);
                      const filtered = dataF.filter(item => 
                        Object.keys(item).some(key => dynamicFilter[key])
                      );
                      filtered.sort((a,b)=>{
                        if(a.data_time===b.data_time){
                            return a.node-b.node;
                        }else{
                            return a.data_time-b.data_time;
                        }
                    }); 
                    setRecordCount(filtered.length)
                    let objList=[
                        {
                            title: '时间   (记录条数:'+filtered.length+')',
                            dataIndex: 'data_time',
                            align: 'center  ',
                        },
                        {
                            title: '探头名称',
                            dataIndex: 'node',
                            key: 'id',
                            align: 'center',
                            render: (text, record) => (
                                <div >
                                    {record.name} 测点：{record.node}
                                </div>
                            )
                        },
                        {
                            title: '温度',
                            dataIndex: 'temp',
                            key: 'id',
                            align: 'center',
                        },
                    ];
                    if(isHumi){
                        objList.push({
                            title: '湿度',
                            dataIndex: 'humi',
                            key: 'id',
                            align: 'center',
                        })
                    }
                    setData(filtered);
                    setSelNodeColums(objList)
                    let ar = filtered.filter(item => item.temp !== 102.3 && item.temp !== 102.2 && item.node!==0
                        &&item.temp !== -102.3 && item.temp !== -102.2 );
                    if(isHumi){
                        ar = ar.filter(item => item.humi !== -102.2&&item.humi !== -102.3&&item.humi !== 102.3 && item.humi !== 102.2);
                    }
                    setdataChart(ar);
                }
                
            }
        })
    }

    function getHisData2(){
        setDataF({tmin: 0, tmax: 0, tavg: 0, hmin: 0, hmax: 0, havg: 0 });
        setdataChart([]);
        setData([]);
        setSeriesTempData([])
        if (selDevice.sn === undefined || selDevice.node === undefined) return message.warning('未选择设备');
        let isShowBoundWT = true
        let isShowBoundWH = true
        let selNodes= selDevice.type===214?selNode.filter(x=>x!==0):selNode
        let devicestateTemp = state_device.devicestate.filter(x=>x.Sn===selDevice.sn&&selNodes.includes(x.Node))
        let fristdevice = devicestateTemp[0].Sensor;
        if(fristdevice.TempWarningLow===fristdevice.TempWarningHigh){
            isShowBoundWT = false
        }
        if(fristdevice.HumiWarningLow===fristdevice.HumiWarningHigh){
            isShowBoundWH = false
            
        }
        devicestateTemp.map(m=>{
            if(isShowBoundWT){
                if(m.Sensor.TempWarningHigh!==fristdevice.TempWarningHigh){
                    isShowBoundWT = false
                }
            }
            if(isShowBoundWH){
                if(m.Sensor.HumiWarningHigh!==fristdevice.HumiWarningHigh){
                    isShowBoundWH = false
                }
            }
            
        })
        setDataWarnT({tl:fristdevice.TempWarningLow,th:fristdevice.TempWarningHigh})
        setDataWarnH({tl:fristdevice.HumiWarningLow,th:fristdevice.HumiWarningHigh})
        setShowBoundWarnT(isShowBoundWT)
        setShowBoundWarnH(isShowBoundWH)
        let url = "/v1"; 
        let start = '';
        let end ='';
        // 普通报表
        if(tableType===0){
            var now_date = new Date(); now_date.setHours(0); now_date.setMinutes(0); now_date.setSeconds(0);
            startTime===''&&setStartTime(formatDateTimes(now_date.getTime()));
            endTime===''&&setEndTime(formatDateTimes(new Date().getTime()));
            start=startTime===''?formatDateTimes(now_date.getTime()):startTime;
            end=endTime===''? formatDateTimes(new Date().getTime()):endTime;
            url += "/historygrounp?device=" + selDevice.sn  + "&starttime=" ;
            url+=start+"&endtime=" + end;
        }else{
            // 周期报表
            if( tableType===3&&monthTime==='')return message.warning('未选择月份');
            if( tableType===2&&startWeek==='')return message.warning('未选择星期');
            if( tableType===1&&startWeek==='')return message.warning('未选择时间');
            let time ='';
            AMTimes.map(item=>item<10?time+=('0'+item+':00:00,'):time+=(item+':00:00,'));
            PMTimes.map(item=>time+=(item+':00:00,'));
            time=time.slice(0,-1);
            
            tableType===3?url+="/historymon?device=":url+="/historyweek?device=";
            url+=selDevice.sn  + "&time=" + time;
            tableType===3?url+=('&mon='+monthTime):endWeek!==''?url+='&starttime='+startWeek+'&endtime='+endWeek:
            url+='&starttime='+startWeek+'&endtime='+formatDateTimes(new Date().getTime());
        }
        url+="&min="+interval+"&node=" + selNodes ;
        setLoading(true);
        setIsHumi(false);
        http.get(url, {})
        .then((data) => { 
            setLoading(false);
            console.log(data);
            // setData(data.data.reverse());
            // let dev_val=[]
            // let sd = selDevs.concat()
            // var nodeCol = new Array();
            // if(sd.length>1){
            //     sd.sort((a,b)=>a.node-b.node);
            //     if(sd[0].node===0){
            //         let temp = sd.splice(0,1);
            //         sd.push(temp[0]);
            //     }
            // }
            // sd.map(({ node, name, district_name, m_name,id,door_alarm ,type,humi}) => {
            //     if (node!==0){
            //         let devNode= dev_val.filter(x=>x.node===node);
            //         let obj ={
            //             title: `${name}-(区域:${district_name}-主机:${m_name}-测点ID:${node})`,
            //             align: 'center',
            //             children: [
            //                 {
            //                     title: `温度 (最大:${devNode.length>0?devNode[0].temp_h.toFixed(1):''} 
            //                         最小:${devNode.length>0?devNode[0].temp_l.toFixed(1):''} 
            //                         平均:${devNode.length>0?devNode[0].temp_s.toFixed(1):''})`,
            //                     align: 'center',
            //                     children:[
                                    
            //                         {
            //                             title: '温度(℃)',
            //                             dataIndex: 'temp' + node,
            //                             align: 'center',
            //                             width:100,
            //                             render: (text, record) => (
            //                                 <div>
            //                                     <div style={{color:record['temp_alarm' + node] === 1 ?'red':''}}>{ record['temp_switch' + node] === 0 ? "--" : text?
            //                                     (text === 102.2||text === 102.3||text === -102.2||text === -102.3) ? " NL" :text.toFixed(1):''}</div>
            //                                 </div>
            //                             )
            //                         },
            //                         {
            //                             title: '状态',
            //                             dataIndex: 'temp_alarm' + node,
            //                             align: 'center',
            //                             width: 60,
            //                             render: (text, record) => (
            //                                 <div style={{color:text === 1 ?'red':''}}>{record['temp_switch' + node] === 0 ? "--" :text === 0 ? '正常' :text === 1 ? '报警':null}</div>
            //                             )
            //                         },
            //                     ]
            //                 }
            //             ]
            //         }
            //         if(showHisLimit){
            //             obj.children[0].children.unshift(
            //                 {
            //                     title: '上下限(℃)',
            //                     dataIndex: 'temp_h' + node,
            //                     align: 'center',
            //                     width:100,
            //                     render: (text, record) => (
            //                         <div>
            //                             {record['temp_switch' + node] === 0 ? null :text===undefined?'': <div>{`${text}~${record['temp_l' + node]}`}</div>}
            //                         </div>
            //                     )
            //                 },
            //             )
            //         }
            //         if (humi!==0){
            //             obj.children.push({
            //                 title: `湿度 (最大:${devNode.length>0?devNode[0].humi_h:''} 
            //                     最小:${devNode.length>0?devNode[0].humi_l:''} 
            //                     平均:${devNode.length>0?devNode[0].humi_s.toFixed(1):''})`,
            //                 align: 'center',
            //                 children:[
            //                     {
            //                         title: '湿度(%RH)',
            //                         dataIndex: 'humi' + node,
            //                         align: 'center',
            //                         width: 100,
            //                         render: (text, record) => (
            //                             <div>
            //                                 <div style={{color:record['humi_alarm' + node] === 1 ?'red':''}}>{ record['humi_switch' + node] === 0 ? "--" : record['humi_enable' + node]===0 ?"--":
            //                                 (text === 102.2||text === 102.3||text === -102.2||text === -102.3) ? " NL" : text?text.toFixed(1):''}</div>
            //                             </div>
            //                         )
            //                     },
            //                     {
            //                         title: '状态',
            //                         dataIndex: 'humi_alarm' + node,
            //                         width: 60,
            //                         align: 'center',
            //                         render: (text, record) => (
            //                             <div style={{color:text === 1 ?'red':''}}>{record['humi_switch' + node] === 0 ? "--" : record['humi_enable' + node]===0 ?"--" :text === 0 ? '正常' : text === 1 ? '报警':''}</div>
            //                         )
            //                     },
            //                 ]
            //             },)
            //             if(showHisLimit){
            //                 obj.children[1].children.unshift(
            //                     {
            //                         title: '上下限(%RH)',
            //                         dataIndex: 'humi_h' + node,
            //                         align: 'center',
            //                         width: 100,
            //                         render: (text, record) => (
            //                             <div>
            //                                 {record['humi_switch' + node] === 0 || record['humi_enable' + node]===0 ? null : text?<div>{`${text}~${record['humi_l' + node]}`}</div>:''}
            //                             </div>
            //                         )
            //                     },
            //                 )
            //             }
            //         }
            //         if(selDevice.type===214){
            //             obj.children.push( {
            //                 title: '门状态',
            //                 align: 'center',
            //                 dataIndex:'door'+node,
            //                 width:80,
            //                 render:(text,record)=>{
            //                     return <div style={{color:text===1?'red':'black'}}>{text===1?'门开启':text===0?'门关闭':''}</div>
            //                 }
            //             })
            //         }
            //         if(selDevice.type===214||selDevice.type===208){
            //             obj.children.push( 
            //             {
            //                 title: '电量',
            //                 align: 'center',
            //                 width:60,
            //                 dataIndex:'battery'+node
            //             }
            //         )}
            //         nodeCol.push(obj)   
            //     }else{
            //         door_alarm===1 &&
            //         nodeCol.push({
            //             title: '门状态',
            //             dataIndex: 'door' + node,
            //             width: 100,
            //             align: 'center',
            //             render: (text, record) => (
            //                 <div>
            //                     <div>{record['door' + node]  === 0 ? "关门" : '开门'}</div>
            //                 </div>
            //             )
            //         })
            //     }
            // })
            // if(selDevice.type!==214){
            //     nodeCol.push( 
            //         {
            //             title: '信号',
            //             dataIndex: 'csq',
            //             align: 'center',
            //             width: 80,
            //         },
            //         {
            //             title: '电源',
            //             dataIndex: selDevice.type===208?'power0':'power',
            //             align: 'center',
            //             width: 80,
            //             render: (text, record) => (
            //                 <div>{text === 0 ? "正常" : text === 1?"电池":''}</div>
            //             )
            //         },
            //         {
            //             title: '电量',
            //             dataIndex: selDevice.type===208?'battery0':'battery',
            //             key: 'id',
            //             align: 'center',
            //             width: 80,
            //         },)
            // }
            // setSelNodeColums(nodeCol)
        })
    }
    return (
        <>
            <div id="devicechart">
                <div className='flexDiv'>
                    <div style={{border:'1px solid #ccc',margin: 10,}}>
                        {/* 设备选择 */}
                        <div style={{ display: 'flex', alignItems: 'center', padding:'10px 20px' ,justifyContent:'space-between'}}>
                            {/* 区域选择 */}    
                            <div style={{display:'flex',alignItems:'center'}}>
                                <span style={{ fontSize: 14 }}>区域</span>
                                <Cascader style={{ width: 300, marginLeft: 10 }}
                                    options={userdistrictlist} expandTrigger="hover" placeholder="选择区域" autoFocus onChange={val => {
                                        // setUserName(state.systemuser.list.filter(x=>x.id===val[val.length-2])[0].name);
                                        setSelNodes(nodeFliters);
                                        setSelDevOptions(devFliters.filter(x=>(Mode==='local'?true :new Date(x.expire).getTime()>todayTime)));
                                        setShowDevName(null);
                                        setShowNodeName([]);
                                        setSelDevice({});
                                        setSelNodeColums([]);
                                        if(val.length===0) return
                                        let arrNode = new Array();
                                        let arrDev = new Array();
                                        state.device.filter(x => x.district === val[val.length - 1].slice(3)*1&&x.node>0).sort((a, b) => a.sn - b.sn).map(m => {
                                            arrNode.push({ label: m.name+'-'+m.sn, value: m.id, sn: m.sn,expire:m.expire });
                                            arrDev.findIndex(x => x.value === m.sn) === -1 && arrDev.push({ label: m.m_name+'-'+m.sn, value: m.sn ,expire:m.expire});
                                        })
                                        setDis(val[val.length - 1].slice(3)*1);
                                        if (arrNode.length === 0) {
                                            message.info('该区域下暂无设备信息');
                                            setSelNodes([])
                                            setSelDevOptions([]);
                                        } else {
                                            setSelNodes(arrNode);
                                            setSelDevOptions(arrDev.filter(x=>(Mode==='local'?true :new Date(x.expire).getTime()>todayTime)));
                                        }
                                        
                                    }} showSearch={(inputValue, path) => path.some(option => option.label.toLowerCase().indexOf(inputValue.toLowerCase()) > -1)} />
                            </div>
                            {/* 主机方式查询 */}
                            <div style={{display:'flex',alignItems:'center'}}>
                                <span margin-left='14px' style={{ fontSize: 14, marginLeft: 10 }}>主机</span>
                                <Select showSearch optionFilterProp="label" allowClear 
                                disabled={showNodeName.length > 0}
                                filterOption={(input, option) =>
                                    option.label.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                }
                                onChange={value => {
                                    setShowDevName(value)
                                    //初始化
                                    setDataF({tmin: 0, tmax: 0, tavg: 0, hmin: 0, hmax: 0, havg: 0 });
                                    setdataChart([]);
                                    setData([]);
                                    let sd;
                                    dis === '' ? sd = state.device.filter(x => x.sn === value) :
                                        sd = state.device.filter(x => x.sn === value && x.district === dis)
                                    if (sd.length > 0) {
                                        setSelDevice(sd[0]);
                                        setUserName(sd[0].user_name);
                                        setIsHumi(sd[0].humi===0?false:true)
                                    } else {
                                        setSelDevice({});
                                        return
                                    }
                                    setSelDevs(sd);
                                    var nodes = new Array();
                                    sd.map(m=>{
                                        nodes.push(m.node);
                                    })
                                    setSelNode(nodes);

                                }}
                                options={selDevOptions}
                                value={showDevName}
                                style={{ width: 260, marginLeft: 10 }}
                                placeholder="选择主机" />
                            </div>
                            {/* 测点方式查询 */}
                            <div style={{display:'flex',alignItems:'center'}}>
                                <span margin-left='14px' style={{ fontSize: 14, marginLeft: 10 }}>测点</span>
                                <Select allowClear showSearch optionFilterProp="children"
                                    mode="multiple"
                                    disabled={!(showDevName === null || showDevName === undefined)}
                                    filterOption={(input, option) =>
                                        option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                    }
                                    value={showNodeName}
                                    maxTagCount = 'responsive'
                                    style={{ width: 360, marginLeft: 10 }}
                                    placeholder="选择测点"
                                    onChange={value => {
                                        setShowNodeName(value);
                                        //初始化
                                        setDataF({tmin: 0, tmax: 0, tavg: 0, hmin: 0, hmax: 0, havg: 0 });
                                        setdataChart([]);
                                        setData([]);
                                        const sd = state.device.filter(x => { return value.indexOf(x.id) > -1 });
                                        if (sd.length > 0) {
                                            setSelDevice(sd[0]);
                                            setUserName(sd[0].user_name);
                                            setSelNodeType(sd[0].type);
                                        } else {
                                            setSelDevice({});
                                            return
                                        }
                                        if(sd.length>1){
                                            sd.sort((a,b)=>a.node-b.node);
                                            if(sd[0].node===0){
                                                let temp = sd.splice(0,1);
                                                sd.push(temp[0]);
                                            }   
                                        }
                                        setSelDevs(sd);
                                        var nodes = new Array();
                                        sd.map(m=>{
                                            nodes.push(m.node);
                                        })
                                        setSelNode(nodes);
                                    }}
                                >
                                    {
                                        selNodes.filter(x => (Mode==='local'?true :new Date(x.expire).getTime()>todayTime)&&(selDevice.sn === undefined ? x.sn > 0 : x.sn === selDevice.sn)).map(item => (
                                            <Select.Option key={item.value} value={item.value}>
                                                {item.label}
                                            </Select.Option>
                                        )) 
                                    }
                                </Select>
                            </div>
                            <Button type={"primary"}  style={{borderRadius:10}} disabled={loading}
                                    onClick={() => {
                                        getHisData(1)
                                        setHisType(1)
                                    }}>大数据查询</Button>
                        </div>
                        {/*时间 报表类型选择   查询*/}
                        <Row align='middle'  style={{padding:'10px 20px'}} >
                            {/* 是否查询周期报表 */}
                            <Col xxl={2} xl={4} lg={4}>
                                <Checkbox onChange={e=>{
                                    if(e.target.checked){
                                    setTableType(3);
                                    }else{
                                        setTableType(0);
                                    }
                                    
                                }}>周期报表</Checkbox>
                            </Col>
                            {/* 周期报表查询 */}
                            <Col xxl={10} xl={tableType>0?16:0} lg={tableType>0?16:0}>
                                <div style={{display:'flex'}}>
                                    {/* 选择周期报表类型月报表|周报表|日报表 */}
                                    <div style={{marginLeft:10}}>
                                        <Tag color={tableType===3?"cyan":'green'} style={{fontSize:14,padding:5,borderRadius:10}}
                                            onClick={()=>{
                                                if(tableType===0)return
                                                setDateTime('');
                                                setMonthTime('');
                                                setStartWeek('');
                                                setEndWeek('');
                                                tableType===3?setTableType(2):tableType===2?setTableType(1):setTableType(3);
                                            }}
                                        >
                                            {tableType===1?'日报表':tableType===2?'周报表':'月报表'}
                                        </Tag>
                                    </div>
                                    {/* 选择周期报表每天上午的时间点 */}
                                    <div style={{marginLeft:10,display:'flex',width:150,alignItems:'center'}}>
                                        <div><span style={{fontSize:14}}>上午:</span></div>
                                        <Select
                                            mode="multiple"
                                            allowClear
                                            style={{ width: '60%',marginLeft:10 }}
                                            placeholder="选择时间点"
                                            defaultValue={[9]}
                                            options = {AMOptions}
                                            onChange={value=>setAMTimes(value)}
                                        />
                                    </div>
                                    {/* 选择周期报表每天下午的时间点 */}
                                    <div style={{marginLeft:10,display:'flex',width:160,alignItems:'center'}}>
                                        <div ><span>下午:</span></div>
                                        <Select
                                            mode="multiple"
                                            allowClear
                                            style={{ width: '60%',marginLeft:10 }}
                                            placeholder="选择时间点"
                                            defaultValue={[15]}
                                            options = {PMOptions}
                                            onChange={value=>setPMTimes(value)}
                                        />
                                    </div>
                                    {/* 选择周期报表查询时间段 */}
                                    <div>
                                        {
                                            tableType===1?
                                            <RangePicker style={{ marginLeft: 10 ,borderRadius:10}}
                                                allowEmpty={[false,true]}
                                                ranges={{
                                                    今天: [moment().startOf('day'), moment()],
                                                    '前一天': [moment().subtract(1, 'days'), moment()],
                                                    '前三天': [moment().subtract(3, 'days'), moment()],
                                                    '前五天': [moment().subtract(5, 'days'), moment()],
                                                    '前七天': [moment().subtract(5, 'days'), moment()],
                                                }}
                                                format="YYYY-MM-DD"
                                                onChange={(dates, dateStrings) => {
                                                    if(dates===null){
                                                        setStartWeek('');
                                                        setEndWeek('');
                                                    }else{
                                                        setStartWeek(dateStrings[0]+' 00:00:00');
                                                        dates[1]!==null&&setEndWeek(dateStrings[1]+' 23:59:59');
                                                    }
                                                    // if (dateStrings[0] !== "") {
                                                    //     setStartWeek(dateStrings[0]+' 00:00:00');
                                                    //     setEndWeek(dateStrings[1]+' 23:59:59');
                                                    // }
                                                }}
                                            />
                                            :
                                            <DatePicker style={{borderRadius:10}}  picker={tableType===1?'date':tableType===2?"week":'month' } 
                                            value={dateTime}  
                                            format={tableType===2&&customWeekStartEndFormat}
                                            onChange ={(value,time)=>{
                                                setDateTime(value)
                                                if(tableType===2){
                                                    setStartWeek(moment(value).startOf('week').format('yyyy-MM-DD HH:mm:ss'));
                                                    setEndWeek(moment(value).endOf('week').format('yyyy-MM-DD HH:mm:ss'));
                                                }else if(tableType===3){
                                                    setMonthTime(time+'-01');
                                                }else{
            
                                                }
                                            }}
                                            />
                                        }
                                    </div>
                                </div>
                            </Col>
                            {/* 普通报表查询 */}
                            <Col xxl={10} xl={tableType===0?16:0} lg={tableType===0?16:0}>
                                <div style={{display:'flex'}}>
                                    {/* 时间选择 */}
                                    <div>
                                        <span margin-left='14px' style={{ fontSize: 14,  }}>选择时间</span>
                                        <RangePicker style={{ marginLeft: 10 ,borderRadius:10}}
                                            allowEmpty={[false,true]}
                                            ranges={{
                                                今天: [moment().startOf('day'), moment()],
                                                '本周': [moment().startOf('week'), moment().endOf('week')],
                                                '本月': [moment().startOf('month'), moment().endOf('month')],
                                                '前一天': [moment().subtract(1, 'days'), moment()],
                                                '前三天': [moment().subtract(3, 'days'), moment()],
                                                '前五天': [moment().subtract(5, 'days'), moment()],
                                                '前七天': [moment().subtract(5, 'days'), moment()],
                                                '一小时': [moment().subtract(1, 'hours'), moment()],
                                                '三小时': [moment().subtract(3, 'hours'), moment()],
                                                '五小时': [moment().subtract(5, 'hours'), moment()],
                                                '六小时': [moment().subtract(6, 'hours'), moment()],
                                            }}
                                            showTime
                                            format="YYYY-MM-DD HH:mm"
                                            onChange={(dates, dateStrings) => {
                                                if(dates===null){
                                                    setStartTime('');
                                                    setEndTime('');
                                                }else{
                                                    setStartTime(dateStrings[0]+':00');
                                                    dates[1]!==null&&setEndTime(dateStrings[1]+':00');
                                                }
                                            }}
                                        />
                                    </div>
                                    {/* 间隔选择 */}
                                    <div>
                                        <span margin-left='14px' style={{ fontSize: 14, marginLeft:20 }}>选择间隔</span>
                                        {
                                            // Mode!=='soc'&&
                                            <Select
                                            showSearch
                                            style={{ width: 80 ,marginLeft:10}}
                                            placeholder="间隔"
                                            optionFilterProp="children"
                                            filterOption={(input, option) =>
                                            option.children.toLowerCase().indexOf(input.toLowerCase()) >= 0
                                            }
                                            filterSort={(optionA, optionB) =>
                                            optionA.children.toLowerCase().localeCompare(optionB.children.toLowerCase())
                                            }
                                            onChange={value=>setInterval(value)}
                                        >
                                            <Option value="1">1</Option>
                                            <Option value="2">2</Option>
                                            <Option value="5">5</Option>
                                            <Option value="10">10</Option>
                                            <Option value="20">20</Option>
                                            <Option value="30">30</Option>
                                            <Option value="60">60</Option>
                                        </Select>
                                        }
                                    </div>
                                    
                                </div>
                            </Col>
                            {/* 查询 */}
                            <Col xxl={1} xl={2} lg={2} style={{display:'flex',justifyContent:'space-between'}}>
                                <div >
                                <Button type={"primary"}  style={{borderRadius:10}} disabled={loading}
                                    onClick={() => {
                                        getHisData(0)
                                        setHisType(0)
                                    }}>查询</Button>
                                     {
                                    Mode==='local' &&
                                    <div>
                                        {/* &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; */}
                                        <span style={{fontSize:10}}>&nbsp;</span>
                                    </div>
                                }
                                 
                                </div>   
                            </Col>
                            <Col xxl={1} xl={2} lg={2} style={{display:'flex',justifyContent:'space-between'}}>
                                <div >
                                <Dropdown trigger={'click'} disabled={loading}
                                    overlay={
                                    <Menu>
                                        {
                                            isHumi&&<Menu.Item key="0">
                                        
                                                <Checkbox style={{marginLeft:5}} checked={isExportHumi} onChange={(e)=>{
                                                    e.target.checked?setIsExportHumi(true):setIsExportHumi(false);
                                                }}>导出湿度</Checkbox>
                                            
                                            </Menu.Item>
                                        }
                                        
                                        <Menu.Item key="1">
                                            <div style={{ border: "0px none", cursor: 'pointer' }} onClick={() => {
                                                exportPDF();
                                            }}>导出PDF</div>
                                        </Menu.Item>
                                        {
                                            !showHisModeNew&&
                                            <Menu.Item key="3">
                                                <div style={{ border: "0px none", cursor: 'pointer' }} onClick={() => {
                                                    exportPDF(1);
                                                }}>PDF(基础)</div>
                                            </Menu.Item>
                                        }
                                        
                                        {
                                            state.super>1&& <Menu.Item key="2">
                                                <div style={{ border: "0px none", cursor: 'pointer' }} onClick={() => {
                                                    exportExcel()
                                                }}>导出EXCEL</div>
                                            </Menu.Item>
                                        }
                                        {
                                            state.super>1&& <Menu.Item key="4">
                                                <div style={{ border: "0px none", cursor: 'pointer' }} onClick={() => {
                                                    exportExcel(1)
                                                }}>EXCEL(基础)</div>
                                            </Menu.Item>
                                        }
                                    
                                    </Menu>
                                }>
                                    <Button type={"primary"}  style={{borderRadius:10,padding:'5px,6px'}}>
                                        {/* <Space> */}
                                        导出
                                        <DownOutlined />
                                        {/* </Space> */}
                                    </Button>
                                </Dropdown>   
                                <div>
                                {
                                    Mode==='local' &&
                                    <div>
                                        {/* &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp; */}
                                        <span style={{color:'red',fontSize:10}}>可导出不能导入</span>
                                    </div>
                                }
                                </div>   
                                </div>                      
                            </Col>
                        </Row>
                    </div>
                    
                    {/* 数据展示区 */}
                    <div style={{ padding: '10px 20px', marginLeft: 10,flex:1,border:'1px solid #ccc'}}className='flexDiv'>
                        {
                            hisType===0&&
                            <div style={{ padding: 5, border: '1px solid #ebedf1', }}>
                                <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                                    <div style={{ width: 100 }}>{selNodeType===205?'压强(Pa)':'温度(℃)'}: </div>
                                    {showHisLimit&&<div style={{ width: 100 }}>上限值:{data.length > 0 ? data[0].temp_h : ''}</div>}
                                    {showHisLimit&&<div style={{ width: 100 }}>下限值:{data.length > 0 ? data[0].temp_l : ''}</div>}
                                    <div style={{ width: 100 }}>最大值:{dataF.tmax}</div>
                                    <div style={{ width: 100 }}>最小值:{dataF.tmin}</div>
                                    <div style={{ width: 100 }}>平均值:{dataF.tavg.toFixed(2)}</div>
                                    {
                                        isHumi&&<div style={{ width: 100 }}>湿度(%RH): </div>
                                    }
                                    {
                                        isHumi&&showHisLimit&&<div style={{ width: 100 }}>上限值:{data.length > 0 ? data[0].humi_h : ''}</div>
                                    }
                                    {
                                        isHumi&&showHisLimit&&<div style={{ width: 100 }}>下限值:{data.length > 0 ? data[0].humi_l : ''}</div>
                                    }
                                    {
                                        isHumi&&<div style={{ width: 100 }}>最大值:{dataF.hmax}</div>
                                    }
                                    {
                                        isHumi&&<div style={{ width: 100 }}>最小值:{dataF.hmin}</div>
                                    }
                                    {
                                        isHumi&&<div style={{ width: 100 }}>平均值:{dataF.havg.toFixed(2)}</div>
                                    }
                                </div>
                            </div>
                        }
                        <div className='flexDiv' style={{flex:1}}>
                        <Spin spinning={loading} size="large" tip="加载中..." />
                        <Tabs defaultActiveKey="1" activeKey={tabKey}  className={`flexDiv`} style={{height:'70vh', visibility:loading?'hidden':'visible',overflow:'hidden'}} 
                            tabBarExtraContent={
                                data&&data.length>0&&
                                <div style={{paddingRight:20}}>
                                    {/* 保存为图片 */}
                                    <Button style={{ borderRadius:10 ,fontSize:12}} onClick={() => {
                                        setLoading(true);
                                        var canvas2 = document.createElement("canvas");
                                        let _canvas = document.getElementById('devicechart');
                                        var w = parseInt(window.getComputedStyle(_canvas).width);
                                        var h = parseInt(window.getComputedStyle(_canvas).height);
                                        canvas2.width = w ;
                                        canvas2.height = h ;
                                        var context = canvas2.getContext("2d");
                                        context.scale(1, 1);
                                        html2canvas(document.getElementById('devicechart'), { canvas: canvas2 }).then((canvas) => {
                                            // canvas.style.width = (w - 40) + "px";
                                            // canvas.style.height = (h - 40) + "px";
                                            canvas.id = 'cutimg'
                                            var url = canvas.toDataURL('image/png');
                                            if(window.CefSharp!==undefined){
                                                window.CefSharp.BindObjectAsync("bound");
                                                window.bound.exportImg(url);
                                     
                                            }else{
                                                var downloadLink = document.createElement("a");
                                                downloadLink.href = url;
                                                downloadLink.download = "sd.png";
                                                downloadLink.click();
                                                
                                            }
                                            setLoading(false);
                                        });
                                        let logmsg = `保存设备${selDevice.sn}中测点ID为 ${selNode}的时间，${startTime}到${endTime}之间的历史数据的${tabKey==='1'?'表格':
                                            tabKey==='2'?'时间轴曲线图':tabKey==='3'?'温度曲线':'湿度曲线'}形式的图片`;
                                        let log={
                                            operator:'',
                                            district:state.device.filter(item=>item.sn===selDevice.sn)[0]?.district_name,
                                            content:logmsg,
                                            result:'导出成功',
                                            contentData:null
                                        }
                                        http.post('/v1/userlog', {
                                            user: state.main.id,
                                            type: 301,
                                            method: 'POST',
                                            log: JSON.stringify(log),
                                            time:formatDateTimes(new Date()),
                                            username:state.main.name,
                                            usertype:state.main.type,
                                            signa:''
                                        }).then(res => {

                                        })
                                    }}>保存为图片</Button>
                                    {/* 下载EXCEL */}
                                    {
                                        state.super>1&&
                                        <Button style={{marginLeft:5,borderRadius:10,fontSize:12}} disabled={state.main.role.indexOf(304)===-1}
                                    onClick={() => {
                                        exportExcel()
                                    }}>导出EXCEL</Button>
                                    }
                                    {
                                        state.super>1&&
                                        <Button style={{marginLeft:5,borderRadius:10,fontSize:12}} disabled={state.main.role.indexOf(304)===-1}
                                    onClick={() => {
                                        exportExcel(1)
                                    }}>EXCEL(基础)</Button>
                                    }
                                    
                                    {/* 下载PDF */}
                                    <Button style={{marginLeft:5,borderRadius:10,fontSize:12}} disabled={state.main.role.indexOf(304)===-1}
                                    onClick={() => {
                                        exportPDF();
                                    }}>导出PDF</Button>
                                    {
                                        !showHisModeNew&&
                                        <Button style={{marginLeft:5,borderRadius:10,fontSize:12}} disabled={state.main.role.indexOf(304)===-1}
                                        onClick={() => {
                                            exportPDF(1);
                                        }}>PDF(基础)</Button>
                                    }
                                    
                                    {
                                        tabKey==='2'&& selNode.length===1&&
                                        <Button style={{ borderRadius:10 ,fontSize:12}} onClick={e=>{
                                            var printContent = document.querySelector('.print-me');
                                            var windowContent = printContent.innerHTML;
                                            let imgUrl = getChartImage();
                                            var printWindow = window.open('', '_blank');
                                            printWindow.document.write('<html><head><title>打印</title>');
                                            printWindow.document.write('</head><body >');
                                            printWindow.document.write(windowContent);
                                            printWindow.document.write("<img src='" + imgUrl + "' alt='ECharts 折线图'/>");
                                            printWindow.document.write('</body></html>');
                                            printWindow.document.close();
                                            printWindow.print();
                                            printWindow.close();
                                    }}>打印</Button>
                                    }
                                    {
                                        isHumi&&<Checkbox style={{marginLeft:5}} checked={isExportHumi} onChange={(e)=>{
                                            e.target.checked?setIsExportHumi(true):setIsExportHumi(false);
                                        }}>湿度</Checkbox>
                                    }
                                    {
                                        Mode==='local' &&
                                        <div>
                                            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                                            <span style={{color:'red',fontSize:10}}>只可导出不能导入</span>
                                        </div>
                                    }
                                    
                                    
                                </div>
                            } 
                            onChange={onChange_Tab}>
                                <TabPane tab="报表显示" key="1" style={{height:'100%',backgroundColor:'#fff'}} className={Mode==='soc'?`hisshow tableshow1`:`flexDiv local`}>
                                    <div>
                                        {
                                            hisType===0?
                                            <Table
                                            rowKey={record =>record.data_time}
                                            bordered
                                            columns={[...columnsLeft, ...selNodeColums]}
                                            scroll={{ x: '80%',
                                                y:state.resolution.height>1000?440:state.resolution.height>800?280:160}}
                                            size={'small'} dataSource={data}  loading={loading}
                                            pagination={{ showSizeChanger:true,current: tableCurrent, onChange:onChange_Table,pageSize:tablePageSize,hideOnSinglePage:true}}
                                            />:
                                            <VirtualTable
                                                columns={selNodeColums}
                                                dataSource={data}
                                                scroll={{
                                                y: state.resolution.height>1000?440:state.resolution.height>800?280:160,
                                                x: '60%',
                                                }}
                                            />
                                        }
                                        
                                    </div>
                                </TabPane>
                                {
                                    hisType===0&&
                                    <TabPane tab="时间轴曲线图" key="2" style={{backgroundColor:'#fff'}} className={Mode==='soc'?`hisshow tableshow1`:`flexDiv local`}>
                                    <div style={{display:'flex',flexDirection:'column',border: '1px solid #ebedf1',height:'100%'}}>
                                        <div></div>
                                        <div  id='tempEcharts'>
                                            {/* <Line {...configtemp} /> */}
                                        </div>
                                        <div style={{display:'flex',justifyContent:'space-between',paddingRight:'10%',paddingLeft:50}}>
                                            <div>
                                                <span>开始时间:</span>
                                                <span>{startTime}</span>
                                            </div>
                                            <div>
                                                <span>结束时间:</span>
                                                <span>{endTime}</span>
                                            </div>
                                        </div>
                                    </div>
                                </TabPane>
                                }
                                
                                <TabPane tab="温度曲线" key="3" style={{backgroundColor:'#fff'}} className={Mode==='soc'?`hisshow tableshow1`:`flexDiv local`}>
                                    <div style={{display:'flex',flexDirection:'column',border: '1px solid #ebedf1',height:'100%'}}>
                                        <div  id='tempEcharts' >
                                            <Line {...configtemp} onReady={antdPointClick}/>
                                        </div>
                                        
                                    </div>
                                    {
                                        dataChart.length>0&&  !showBound&&
                                        <div style={{textAlign:'center'}}>
                                            <span style={{fontSize:10,color:'red'}}>您选择的测点包含多个温（湿）度区间或者是空库，故不展示区间辅助线</span>
                                        </div>
                                    }
                                </TabPane>
                                {
                                    isHumi&&
                                    <TabPane tab="湿度曲线" key="4"  style={{backgroundColor:'#fff'}} className={Mode==='soc'?`hisshow tableshow1`:`flexDiv local`}>
                                        <div style={{display:'flex',flexDirection:'column', border: '1px solid #ebedf1', padding: 10 ,height:'100%'}} >
                                            <div id='tempEcharts' >
                                                <Line {...confighumi} onReady={antdPointClick} />
                                            </div>
                                            
                                        </div>
                                        {
                                            dataChart.length>0&& !showBound&&
                                            <div style={{textAlign:'center'}}>
                                                <span style={{fontSize:10,color:'red'}}>您选择的测点包含多个温（湿）度区间或者是空库，故不展示区间辅助线</span>
                                            </div>
                                        }
                                    </TabPane>
                                }
                        </Tabs>
                            
                        </div>
                    </div>
                    {/* 下载区 */}
                    <div style={{ marginTop: 10, textAlign: 'right' }}>
                        <a id="downloadDiv" style={{ display: 'none' }}></a>
                    </div>
                </div>
                {/* 打印 */}
                <div className='print-me' style={{display:'none'}}>
                    <div style={{fontSize:26}}>
                        <span>设备编号：</span>
                        <span style={{marginLeft:5}}>{selDevice.sn}</span>
                        <span style={{marginLeft:10}}>用户：</span>
                        <span style={{marginLeft:5}}>{state.main.name}</span>
                        <span style={{marginLeft:10}}>单位：</span>
                        <span style={{marginLeft:5}}>{userName}</span>
                    </div>
                    <div style={{fontSize:26}}>
                        <span>区域：</span>
                        <span style={{marginLeft:5}}>{selDevice.district_name}</span>
                        <span style={{marginLeft:20}}>名称：</span>
                        <span style={{marginLeft:5}}>{`${selDevice.name}-探头编号-${selDevice.node}`}</span>
                    </div>
                    <div style={{fontSize:26}}>
                        <span>开始时间：</span>
                        <span style={{marginLeft:5}}>{startTime}</span>
                        <span style={{marginLeft:20}}>结束时间：</span>
                        <span style={{marginLeft:5}}>{endTime}</span>
                    </div>
                    <div style={{fontSize:26}}>
                        <span>温度</span>
                        <span style={{marginLeft:20}}>最大值：</span>
                        <span style={{marginLeft:5}}>{selDevice.type===211?dataF.tmax.toFixed(2):dataF.tmax.toFixed(1)}</span>
                        <span style={{marginLeft:20}}>最小值：</span>
                        <span style={{marginLeft:5}}>{selDevice.type===211?dataF.tmin.toFixed(2):dataF.tmin.toFixed(1)}</span>
                        <span style={{marginLeft:20}}>平均值：</span>
                        <span style={{marginLeft:5}}>{selDevice.type===211?dataF.tavg.toFixed(2):dataF.tavg.toFixed(1)}</span>
                    </div>
                    {
                        selDevice.humi===1&&
                        <div style={{fontSize:26}}>
                            <span>湿度</span>
                            <span style={{marginLeft:20}}>最大值：</span>
                            <span style={{marginLeft:5}}>{}</span>
                            <span style={{marginLeft:5}}>{selDevice.type===211?dataF.hmax.toFixed(2):dataF.hmax.toFixed(1)}</span>
                            <span style={{marginLeft:20}}>最小值：</span>
                            <span style={{marginLeft:5}}>{selDevice.type===211?dataF.hmin.toFixed(2):dataF.hmin.toFixed(1)}</span>
                            <span style={{marginLeft:20}}>平均值：</span>
                            <span style={{marginLeft:5}}>{selDevice.type===211?dataF.havg.toFixed(2):dataF.havg.toFixed(1)}</span>
                        </div>
                    }
                    <div>
                        <table style={{textAlign:'center',fontSize:26}}>
                            <thead >
                                <tr>
                                    <th style={{border:'1px solid #ccc'}}>时间</th>
                                    <th style={{borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>温度</th>
                                    {
                                        selDevice.humi===1&&
                                        <th style={{borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc',borderLeft:'1px solid #ccc'}}>湿度</th>
                                    }
                                    
                                    <th style={{border:'1px solid #ccc'}}>时间</th>
                                    <th style={{borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>温度</th>
                                    {
                                        selDevice.humi===1&&
                                        <th style={{borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc',borderLeft:'1px solid #ccc'}}>湿度</th>
                                    }
                                    <th style={{border:'1px solid #ccc'}}>时间</th>
                                    <th style={{borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc',borderRight:'1px solid #ccc'}}>温度</th>
                                    {
                                        selDevice.humi===1&&
                                        <th style={{borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc',borderRight:'1px solid #ccc'}}>湿度</th>
                                    }
                                    {/* <th style={{border:'1px solid #ccc'}}>时间</th>
                                    <th style={{borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>温度</th>
                                    {
                                        selDevice.humi===1&&
                                        <th style={{borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>湿度</th>
                                    } */}
                                </tr>
                                
                            </thead>
                            <tbody>
                                {
                                    selNode.length===1&&
                                    dataP.map((item,index) => {
                                        if(index%3===0){
                                            return<tr>
                                            <td style={{border:'1px solid #ccc'}}>{item.data_time}</td>
                                            <td style={{width:80,marginLeft:5,borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>
                                                {item.temp_switch===0?'--':
                                    (item.temp===102.2||item.temp===102.3||item.temp===-102.2||item.temp===-102.3)?'NL':item.type===211?item.temp.toFixed(2):item.temp.toFixed(1)}</td>
                                            {
                                                selDevice.humi===1&&
                                                <td style={{width:80,marginLeft:5,borderLeft:'1px solid #ccc',borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>
                                                    {(item.humi===102.2||item.humi===102.3||item.humi===-102.2||item.humi===-102.3)?'NL':item.humi.toFixed(1)}
                                                </td>
                                            }
                                            {
                                                ((index+1)<recordCount)&&<td style={{border:'1px solid #ccc'}}>{data[index+1]?.data_time}</td>
                                            }
                                            {
                                                ((index+1)<recordCount)&&<td style={{width:80,marginLeft:5,borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>
                                                    {data[index+1]?.temp_switch===0?'--':
                                                    (data[index+1]?.temp===102.2||data[index+1]?.temp===102.3||data[index+1]?.temp===-102.2||data[index+1]?.temp===-102.3)?'NL':data[index+1]?.type===211?data[index+1]?.temp.toFixed(2):data[index+1]?.temp.toFixed(1)
                                                    }
                                                </td>
                    
                                            }
                                            {
                                                ((index+1)<recordCount)&&selDevice.humi===1&&
                                                <td style={{width:80,marginLeft:5,borderLeft:'1px solid #ccc',borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>
                                                    {(data[index+1]?.humi===102.2||data[index+1]?.humi===102.3||data[index+1]?.humi===-102.2||data[index+1]?.humi===-102.3)?'NL':data[index+1]?.humi.toFixed(1)}
                                                </td>
                                            }    
                                            {
                                                ((index+2)<recordCount)&&(<td style={{border:'1px solid #ccc'}}>{data[index+2]?.data_time}</td>)
                                            }
                                            {
                                                ((index+2)<recordCount)&&(<td style={{width:80,marginLeft:5,borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc',borderRight:'1px solid #ccc'}}>
                                                    {data[index+2]?.temp_switch===0?'--':(data[index+2]?.temp===102.2||data[index+2]?.temp===102.3||data[index+2]?.temp===-102.2||data[index+2]?.temp===-102.3)?'NL':
                                                data[index+2]?.type===211?data[index+2]?.temp.toFixed(2):data[index+2]?.temp.toFixed(1)}
                                                </td>)
                                            }
                                            {
                                                ((index+2)<recordCount)&&selDevice.humi===1&&
                                                <td style={{width:80,marginLeft:5,borderRight:'1px solid #ccc',borderTop:'1px solid #ccc',borderBottom:'1px solid #ccc'}}>
                                                    {(data[index+2]?.humi===102.2||data[index+2]?.humi===102.3||data[index+2]?.humi===-102.2||data[index+2]?.humi===-102.3)?'NL':data[index+2]?.humi.toFixed(1)}
                                                </td>
                                            }
                                            {/* {
                                                ((index+3)<recordCount)&&(<td style={{borderLeft:'1px solid #ccc'}}>{data[index+3].data_time}</td>)
                                            }
                                            {
                                                ((index+3)<recordCount)&&(<td style={{width:80,marginLeft:5,borderLeft:'1px solid #ccc'}}>{data[index+3].temp_switch===0?'--':
                                    (data[index+3].temp===102.2||data[index+3].temp===102.3||data[index+3].temp===-102.2||data[index+3].temp===-102.3)?'NL':data[index+3].type===211?data[index+3].temp.toFixed(2):data[index+3].temp.toFixed(1)}</td>)
                                            }
                                            {
                                                ((index+3)<recordCount)&&selDevice.humi===1&&
                                                <td style={{width:80,marginLeft:5,borderLeft:'1px solid #ccc'}}>
                                                    {(data[index+3].humi===102.2||data[index+3].humi===102.3||data[index+3].humi===-102.2||data[index+3].humi===-102.3)?'NL':data[index+3].humi.toFixed(1)}
                                                </td>
                                            } */}
                                        </tr>
                                        }
                                    }
                                        
                                    )
                                }
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </>
    )
}

export default History